import { SubscriptionType } from '@uma/react-commons/dist/index';
import { SubscriptionsProps } from 'src/components/SubscriptionsCard/types';

export function getResourceId(subscription: SubscriptionsProps): string {
  return subscription?.type === SubscriptionType.HP_ALL_IN
    ? subscription?.friendlyId
    : subscription?.resourceId;
}
